<template>
  <NotificationToast />
  <router-view />
</template>
<script lang="ts">
import { defineComponent } from "vue";
import NotificationToast from "./components/NotificationToast.vue";
export default defineComponent({
  mounted() {
    const pkg = require("../package.json");
    console.log("VERSION:", `${pkg.version} - ${process.env.VUE_APP_ENV_NAME}`);
  },
  created() {
    document.title = "Diag | Farmácias";
  },
  components: {
    NotificationToast,
  },
});
</script>
